import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSignOfLifeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.74976 11H3.62488L5 9.74998L6.25 13.25L8.75 2.75L11.25 12L12.25 11L14.25 11" })
});
export default SvgSignOfLifeIcon;
